import * as LodashFP from 'lodash/fp'

import { FormBlueprint } from '../../interfaces/components/dynamic-form'

export const PerformanceAdvertisingFormatset: FormBlueprint = {
  name: 'performance-advertising-formatset',
  fields: [
    {
      step: 10,
      type: 'select',
      name: 'fs_formats',
      label: 'Format selection',
      mandatory: true,
      description: '',
      meta: {
        as: 'checkboxes',
        multiple: true,
        options: [{ label: 'Native', value: 'Native' }],
      },
    },
    {
      step: 20,
      type: 'select',
      name: 'fs_no_of_motives',
      label: 'Recommended number of motives',
      mandatory: true,
      description: '',
      meta: {
        as: 'arrows',
        multiple: false,
        options: LodashFP.range(1, 11).map((n: any) => {
          return { label: n, value: n }
        }),
      },
    },
  ],
}

export const FacebookFormatset: FormBlueprint = {
  name: 'facebook-formatset',
  fields: [
    {
      step: 10,
      type: 'select',
      name: 'fs_type',
      label: 'Type',
      mandatory: true,
      description: '',
      meta: {
        as: 'grid',
        multiple: false,
        options: [
          { label: 'Auction', value: 'Auction' },
          { label: 'Reach and Frequency', value: 'Reach and Frequency' },
        ],
      },
    },

    {
      step: 20,
      type: 'select',
      name: 'fs_objective',
      label: 'Objective',
      description: 'Description for objective',
      mandatory: true,
      meta: {
        as: 'dropdown',
        multiple: false,
        options: [
          { value: 'Traffic', label: 'Traffic' },
          { value: 'Whatever', label: 'Whatever' },
        ],
      },
    },

    {
      step: 30,
      type: 'select',
      name: 'fs_device',
      label: 'Device',
      mandatory: true,
      description: '',
      meta: {
        as: 'grid',
        multiple: false,
        options: [
          { label: 'Mobile', value: 'Mobile' },
          { label: 'Desktop', value: 'Desktop' },
        ],
      },
    },

    {
      step: 40,
      type: 'select',
      name: 'fs_place',
      label: 'Place',
      mandatory: true,
      description: '',
      meta: {
        as: 'grid',
        multiple: true,
        options: [
          { label: 'Facebook', value: 'Facebook' },
          { label: 'Instagram', value: 'Instagram' },
          { label: 'Messenger', value: 'Messenger' },
          { label: 'Audience', value: 'Audience' },
        ],
      },
    },

    {
      step: 50,
      type: 'select',
      name: 'fs_placements',
      label: 'Placements',
      mandatory: true,
      description: '',
      meta: {
        as: 'dropdown',
        multiple: true,
        options: [
          { label: 'Stories', value: 'Stories' },
          { label: 'Feeds', value: 'Feeds' },
          { label: 'Right hand column', value: 'Right hand column' },
        ],
      },
    },

    {
      step: 60,
      type: 'select',
      name: 'fs_formats',
      label: 'Format selection',
      mandatory: true,
      description: '',
      meta: {
        as: 'checkboxes',
        multiple: true,
        options: [
          { label: 'Image', value: 'Image' },
          { label: 'Video', value: 'Video' },
          { label: 'Carousel', value: 'Carousel' },
          { label: 'Slideshow', value: 'Slideshow' },
        ],
      },
    },

    {
      step: 70,
      type: 'select',
      name: 'fs_no_of_motives',
      label: 'Recommended number of motives',
      mandatory: true,
      description: '',
      meta: {
        as: 'arrows',
        multiple: false,
        options: LodashFP.range(1, 11).map((n: any) => {
          return { label: n, value: n }
        }),
      },
    },
  ],
}
